var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEveryone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 8.83341C14.3411 8.83341 15.8335 7.34103 15.8335 5.50008C15.8335 3.65913 14.3411 2.16675 12.5002 2.16675M14.1668 18.8334H16.5002C17.9729 18.8334 19.1668 17.6395 19.1668 16.1667C19.1668 13.9576 17.376 12.1667 15.1668 12.1667H14.1668M10.0002 5.50008C10.0002 7.34103 8.50778 8.83341 6.66683 8.83341C4.82588 8.83341 3.3335 7.34103 3.3335 5.50008C3.3335 3.65913 4.82588 2.16675 6.66683 2.16675C8.50778 2.16675 10.0002 3.65913 10.0002 5.50008ZM3.50017 18.8334H9.8335C11.3063 18.8334 12.5002 17.6395 12.5002 16.1667C12.5002 13.9576 10.7093 12.1667 8.50016 12.1667H4.8335C2.62436 12.1667 0.833496 13.9576 0.833496 16.1667C0.833496 17.6395 2.02741 18.8334 3.50017 18.8334Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEveryone);
export default ForwardRef;